import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Plyr from 'plyr';
require('../../node_modules/plyr/dist/plyr.css');

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('hero');

    const initDesktop = function() {

        const btn = el.getElementsByClassName('js-controlBtn')[0];
        const btnSound = el.getElementsByClassName('js-sountBtn')[0];
        
        const names = btn.dataset.names;
        const arr = names.split(',');
        const name_pause = arr[0].toString(),
              name_resume = arr[1].toString(),
              name_repeat = arr[2].toString();
              
        const names_sound = btnSound.dataset.names,
              arr_sound = names_sound.split(','),
              name_sound_on = arr_sound[0].toString(),
              name_sound_off = arr_sound[1].toString();

        window.heroPlay = true;        
              
        const player = new Plyr('#heroVideoDesktop', {
            autoplay: true,
            muted: true,
            controls: false
        });

        btn.addEventListener('click', function(e) {
            if (player.paused) {
                player.play();
                window.heroPlay = true;
                btn.innerHTML = name_pause; 
            } else if (player.paused) {
                player.play();
                window.heroPlay = true;
                btn.innerHTML = name_pause; 
            } else {                
                player.pause();
                window.heroPlay = false;
                btn.innerHTML = name_resume;
            }
            
            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        })
        
        btnSound.addEventListener('click', function(e) {
            if (player.muted) {
                player.muted = false;
                player.volume = 1;
                btnSound.classList.add('on');
                btnSound.innerHTML = name_sound_off; 
            } else {
                player.muted = true;
                btnSound.classList.remove('on');
                btnSound.innerHTML = name_sound_on; 
            }

            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        })
        
        const enterBackFunc = function() {
            if (window.heroPlay === true) {
                player.play();
            }
        } 
        
        const leaveFunc = function() {
            if (!player.paused) {
                player.pause();
            }
        }       
        
        ScrollTrigger.create({
            trigger: '#hero',
            start: 'top-=100% bottom',
            onEnterBack: enterBackFunc,
            onLeave: leaveFunc,
        });
        
        player.on('ended', (event) => {
            btn.innerHTML = name_repeat;
        });
        
        player.muted = true;
        player.play();
    };
    
    const initMobile = function() {              
        const player = new Plyr('#heroVideoMobile', {
            autoplay: true,
            muted: true, 
            volume: 0,
            controls: true
        });
        
        const enterBackFunc = function() {
            if (window.heroPlay === true) {
                player.play();
            }
        } 
        
        const leaveFunc = function() {
            if (!player.paused) {
                player.pause();
            }
        }       
        
        player.play();        
    };

    
    if (document.documentElement.classList.contains('desktop')) {
        el ? initDesktop() : false; 
    } else {
        //el ? initMobile() : false; 
    }

}, false)
